/* eslint-disable react/require-default-props */
import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styled, { css } from 'styled-components';
import { BaseProps } from './types';
import styles from './Button.module.css';
import PulsatingCircle from '../PulsatingCircle';

const BoxBorder = css`
  background-color: var(--background-button);
  box-shadow: var(--shadow-modal);
  border: 1px solid var(--border-modal);
`;

const HasFitContentWidth = css`
  width: fit-content;
`;

const WithAccentTextColor = css`
  color: var(--accent);
`;

const ButtonBase = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-radius: 8px;
  padding: 10px 15px !important;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  height: fit-content;
  line-height: 21px;
  position: relative;
`;

const Loading = css`
  position: relative;
  color: rgba(0, 0, 0, 0);
`;
const Small = css`
  border-radius: 4px;
  padding: 5px 12px !important;
  height: auto;
`;

const Disabled = css`
  opacity: 0.5;
  cursor: not-allowed;
  &:hover {
    opacity: 0.5;
    cursor: not-allowed;
    border: 1px solid var(--border-modal);
    color: var(--text-lighter);
  }
`;

const StyledButton = styled.button<{ isLoading: boolean, isSmall: boolean, isDisabled: boolean }>`
  ${BoxBorder}
  ${HasFitContentWidth}
  ${WithAccentTextColor}
  ${ButtonBase}
  ${(props) => props.isLoading && Loading}
  ${(props) => props.isSmall && Small}
  ${(props) => props.isSmall && Small}
  ${(props) => props.isDisabled && Disabled}
`;

const StyledPulsatingCircle = styled(PulsatingCircle)`
  position: absolute;
  left: 100% !important;
  top: 0px !important;
`;
function ButtonBoxBorder({
  className,
  onClick,
  children,
  disabled,
  loading,
  small,
  showNotif,
  ...props
}: PropsWithChildren<{
  onClick?: any;
  disabled?: boolean;
  loading?: boolean;
  small?: boolean;
  showNotif?: boolean;
}> &
BaseProps) {
  return (
    <StyledButton
      isLoading={!!loading}
      isSmall={!!small}
      isDisabled={!!disabled}
      type="button"
      className={classNames(className)}
      onClick={disabled || loading ? () => {} : onClick}
      disabled={disabled}
      {...props}
    >
      {loading && (
      <span
        className={classNames('loader is-loading mr-1 with-accent-border-color', styles.accentLoader)}
      />
      )}
      {children}
      {showNotif && !loading
        ? <StyledPulsatingCircle className={styles.notifTopRight} small /> : null}
    </StyledButton>
  );
}

export default ButtonBoxBorder;
